// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiselect {
  min-width: 400px;
}

.css-b62m3t-container .css-1s2u09g-control {
  border-color: #e4e6ef !important;
  min-height: 500 !important;
}

.check {
  margin-top: 10px;
}

.spaceBetween {
  display: flex;
  justify-content: space-between;
}

.itemModal {
  padding: 25px 20px;
}
.itemModal h6 {
  margin-bottom: 20px;
}
.itemModal div {
  margin-bottom: 10px;
  font-size: 13px;
  color: #5e6278;
}
.itemModal div strong {
  margin-right: 10px;
  font-size: 1.1rem;
}

.tableContact {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
}

.rowContatc {
  display: flex;
  height: 25px;
}
.rowContatc div {
  width: 300px;
  border: 2px solid rgba(0, 0, 0, 0.144);
}

.buttonTables button {
  background-color: inherit;
  border: none;
  outline: none;
  margin-right: 10px;
  cursor: pointer;
  width: 30px;
}

.container-data {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rowInputs {
  padding: 5px;
}

.trTable {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #181c32 !important;
}

.teste {
  width: 50px;
  height: 250px;
}

.buttonOptionsPessoa {
  margin-top: 30px;
  background-color: inherit;
  border: none;
  outline: none;
  margin-right: 10px;
  cursor: pointer;
  width: 30px;
}

@media (max-width: 1210px) {
  .containerSelects {
    display: flex;
    flex-direction: column;
  }
  .containerSelects select {
    width: 205%;
  }
  .multiselect {
    width: 205%;
  }
}
@media (max-width: 1100px) {
  .containerSelects select {
    width: 207%;
  }
  .multiselect {
    width: 207%;
  }
}
@media (max-width: 880px) {
  .containerSelects select {
    width: 209%;
  }
  .multiselect {
    width: 209%;
  }
}
@media (max-width: 767px) {
  .containerSelects {
    display: flex;
    flex-direction: column;
  }
  .containerSelects select {
    width: 100%;
  }
  .multiselect {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Financeiro/ImprimirRecibos/Imprimir/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,gCAAA;EACA,0BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,mBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAEI;EACE,kBAAA;EACA,iBAAA;AAAN;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;AAFF;AAIE;EACE,YAAA;EACA,sCAAA;AAFJ;;AAOE;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAJJ;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AALF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,2BAAA;EACA,0BAAA;EACA,yBAAA;AAJF;;AAOA;EACE,WAAA;EACA,aAAA;AAJF;;AAOA;EACE,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAJF;;AAOA;EACE;IACE,aAAA;IACA,sBAAA;EAJF;EAME;IACE,WAAA;EAJJ;EAQA;IACE,WAAA;EANF;AACF;AASA;EAEI;IACE,WAAA;EARJ;EAYA;IACE,WAAA;EAVF;AACF;AAaA;EAEI;IACE,WAAA;EAZJ;EAgBA;IACE,WAAA;EAdF;AACF;AAiBA;EACE;IACE,aAAA;IACA,sBAAA;EAfF;EAiBE;IACE,WAAA;EAfJ;EAmBA;IACE,WAAA;EAjBF;AACF","sourcesContent":[".multiselect {\n  min-width: 400px;\n}\n\n.css-b62m3t-container .css-1s2u09g-control {\n  border-color: #e4e6ef !important;\n  min-height: 500 !important;\n}\n\n.check {\n  margin-top: 10px;\n}\n\n.spaceBetween {\n  display: flex;\n  justify-content: space-between;\n}\n\n.itemModal {\n  padding: 25px 20px;\n\n  h6 {\n    margin-bottom: 20px;\n  }\n\n  div {\n    margin-bottom: 10px;\n    font-size: 13px;\n    color: #5e6278;\n\n    strong {\n      margin-right: 10px;\n      font-size: 1.1rem;\n    }\n  }\n}\n\n.tableContact {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n}\n\n.rowContatc {\n  display: flex;\n  height: 25px;\n\n  div {\n    width: 300px;\n    border: 2px solid rgba(0, 0, 0, 0.144);\n  }\n}\n\n.buttonTables {\n  button {\n    background-color: inherit;\n    border: none;\n    outline: none;\n    margin-right: 10px;\n    cursor: pointer;\n    width: 30px;\n  }\n}\n\n.container-data {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.rowInputs {\n  padding: 5px;\n}\n\n.trTable {\n  font-weight: 600 !important;\n  font-size: 14px !important;\n  color: #181c32 !important;\n}\n\n.teste {\n  width: 50px;\n  height: 250px;\n}\n\n.buttonOptionsPessoa {\n  margin-top: 30px;\n  background-color: inherit;\n  border: none;\n  outline: none;\n  margin-right: 10px;\n  cursor: pointer;\n  width: 30px;\n}\n\n@media (max-width: 1210px) {\n  .containerSelects {\n    display: flex;\n    flex-direction: column;\n\n    select {\n      width: 205%;\n    }\n  }\n\n  .multiselect {\n    width: 205%;\n  }\n}\n\n@media (max-width: 1100px) {\n  .containerSelects {\n    select {\n      width: 207%;\n    }\n  }\n\n  .multiselect {\n    width: 207%;\n  }\n}\n\n@media (max-width: 880px) {\n  .containerSelects {\n    select {\n      width: 209%;\n    }\n  }\n\n  .multiselect {\n    width: 209%;\n  }\n}\n\n@media (max-width: 767px) {\n  .containerSelects {\n    display: flex;\n    flex-direction: column;\n\n    select {\n      width: 100%;\n    }\n  }\n\n  .multiselect {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
